/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createTRPCReact,
  type inferReactQueryProcedureOptions,
} from '@trpc/react-query';
import type { RouterLike, UtilsLike } from '@trpc/react-query/shared';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import {
  ProblemDetailsErrorSchema,
  ValidationErrorSchema,
} from 'pos-server/backendSchemas/problemDetailsSchema.ts';
import type { ApiRouterType } from 'pos-server/trpc/apiRouter.ts';
import type {
  DotPathIndex,
  ExtractPathsToContainingKey,
} from 'pos-shared/utils/type-utils.ts';

export const trpc = createTRPCReact<ApiRouterType>();

export const handleAdminPortalError = (error: any) => {
  const problemDetails = error.data?.problemDetails;
  const description = Array.isArray(problemDetails?.message)
    ? problemDetails?.message.map((item: any) => item.message).join(', ')
    : Object.values(problemDetails?.message?.errors).join(', ');

  return description;
};

export const extractValidationErrorDetails = (error: any) => {
  // handle problem details error format
  const problemDetailsString = error?.data?.problemDetails?.detail;

  if (problemDetailsString) {
    const parsed = ValidationErrorSchema.safeParse(problemDetailsString);

    return parsed.success ? parsed.data : undefined;
  }
};
export const extractProblemDetails = (error: any) => {
  // handle problem details error format

  const problemDetailsString = error?.data?.problemDetails;

  if (problemDetailsString) {
    const parsed = ProblemDetailsErrorSchema.safeParse(problemDetailsString);

    return parsed.success ? parsed.data : undefined;
  }
};

export type ApiRouterLike = RouterLike<ApiRouterType>;
export type ApiRouterUtils = UtilsLike<ApiRouterType>;
export type ApiReactQueryOptions =
  inferReactQueryProcedureOptions<ApiRouterType>;
export type ApiRouterInputs = inferRouterInputs<ApiRouterType>;
export type ApiRouterOutputs = inferRouterOutputs<ApiRouterType>;

export type ApiRouterQueries = ExtractPathsToContainingKey<
  ApiRouterLike,
  'useQuery'
>;
export type TrpcRouterIndex<T extends ApiRouterQueries> = DotPathIndex<
  ApiRouterType,
  T
>;
export type TrpcRouterLikeIndex<T extends ApiRouterQueries> = DotPathIndex<
  ApiRouterLike,
  T
>;
export type TrpcRouterInputsIndex<T extends ApiRouterQueries> = DotPathIndex<
  ApiRouterInputs,
  T
>;
export type TrpcRouterOutputsIndex<T extends ApiRouterQueries> = DotPathIndex<
  ApiRouterOutputs,
  T
>;
